import useWebChatAPIContext from '/druid/internal/useWebChatAPIContext';

export default function useRenderAttachment() {
  const { attachmentRenderer } = useWebChatAPIContext();

  return attachmentRenderer;
}
